import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const flexibilityApi = factory.get("flexibility");

const initialState = {
  flexibility: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      is_all_shift: "false",
      is_start: "true",
      name: "",
      date: dayjs().format("YYYY-MM-DD"),
      start_time: dayjs().format("YYYY-MM-DD HH:mm:00"),
      end_time: dayjs().format("YYYY-MM-DD HH:mm:00"),
      duration: 60,
      note: "",
      departments: [],
    },
  },
  flexibilitys: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const flexibilitySlice = createSlice({
  name: "flexibility",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.flexibility.dialog = !state.flexibility.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.flexibilitys.data = payload.data.data;
      state.flexibilitys.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.flexibility.form.id = payload.id;
      state.flexibility.form.name = payload.name;

      state.flexibility.form.start_time = payload.start_time;
      state.flexibility.form.end_time = payload.end_time;
      state.flexibility.form.duration = payload.duration;

      state.flexibility.form.is_all_shift = payload.is_all_shift
        ? "true"
        : "false";
      state.flexibility.form.is_start = payload.is_start ? "true" : "false";
      state.flexibility.form.date = dayjs(payload.start_time).format(
        "YYYY-MM-DD"
      );
      state.flexibility.form.note = payload.note;
      state.flexibility.form.departments = payload.departments || [];
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.flexibility.form = initialState.flexibility.form;
    },
  },
});

export const { setLoading, setDialog, setDataTable, setById, resetForm } =
  flexibilitySlice.actions;

export default flexibilitySlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("flexibilitys"));
    const res = await flexibilityApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("flexibilitys"));
  } catch (err) {
    dispatch(setLoading("flexibilitys"));
    throw new Error(err);
  }
};
const deleteById = (id) => async (dispatch) => {
  try {
    await flexibilityApi.delete(id);
    dispatch(
      showNotification({
        message: "تم حذف البيانات بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("flexibility"));
    const res = await flexibilityApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setDialog());
    dispatch(setLoading("flexibility"));
  } catch (err) {
    dispatch(setLoading("flexibility"));
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("flexibility"));
    const xdata = {
      ...data,
      is_all_shift: data.is_all_shift === "true" ? true : false,
      is_start: data.is_start === "true" ? true : false,
      start_time: `${data.date} ${dayjs(data.start_time).format("HH:mm:00")}`,
      end_time: `${data.date} ${dayjs(data.end_time).format("HH:mm:00")}`,
    };
    await flexibilityApi.create(xdata);
    dispatch(getAll());
    dispatch(setDialog());
    dispatch(setLoading("flexibility"));
  } catch (err) {
    dispatch(setLoading("flexibility"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("flexibility"));
    const xdata = {
      ...data,
      is_all_shift: data.is_all_shift === "true" ? true : false,
      is_start: data.is_start === "true" ? true : false,
      start_time: `${data.date} ${dayjs(data.start_time).format("HH:mm:00")}`,
      end_time: `${data.date} ${dayjs(data.end_time).format("HH:mm:00")}`,
    };
    await flexibilityApi.update(data.id, xdata);
    dispatch(setDialog());
    dispatch(getAll());
    dispatch(setLoading("flexibility"));
  } catch (err) {
    dispatch(setLoading("flexibility"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    throw new Error(err);
  }
};

export const Flexibility = {
  getAll,
  deleteById,
  getById,
  create,
  update,
};
